/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-6 18:01:19
 */
import moment from 'moment'
import i18n from '@/locales/index'
import { getLanguage } from '@/utils/cookies'
const $t = i18n.global.t

export const getHM = (value?: any) => {
	if (value == 0) {
		// 显示0秒
		return value + $t('robot.seconds')
	}
	const _h = value / 3600
	const tempTime = moment.duration(value, 's');
	const h = tempTime.hours() ? Math.floor(_h) + $t('robot.hours') : ''
	const m = tempTime.minutes() ? tempTime.minutes() + $t('robot.minutes') : ''
	const t = tempTime.seconds() ? tempTime.seconds() + $t('robot.seconds') : ''
	return h + m + t;
}

export const getHMS = (time?: any) => {
	if (isNaN(Number(time))) return time
	const h = time >= 3600 ? Math.floor(time / 3600) : 0
	const min = (time - h * 3600) >= 60 ? Math.floor((time - h * 3600) / 60) : 0
	const second = time - h * 3600 - min * 60
	let str = h > 0 ? String(h).padStart(2, '0') + ':' : '00:'
	str = str + (min > 0 ? String(min).padStart(2, '0') + ':' : '00:')
	str = str + (second > 0 ? String(second).padStart(2, '0') : '00')
	return str
}


export const totalImg = () => {
	const files = require.context('@/assets/images/home', false, /\.png|.svg$/);
	const images = {};
	files.keys().forEach(key => {
		// images[key.replace(/(\.\/|\.png)/g, "")] = '@/static/img'+key.substring(1, key.length);
		images[key.replace(/(\.\/|\.png|.svg)/g, '')] = files(key);
	});
	return images;
}

export const setRobotName = (val?: any) => {
	if (val == undefined) return
	const a = val.substring(0, 10),
		len = val.length,
		b = val.substring(len - 4, len);
	const c = (a + b).toUpperCase()
	return c
}
export const disinfectType = (key?: any) => {
	let val = ''
	switch (key) {
		case 'disinfect':
			val = $t('robot.InSitu_disinfect')
			break
		case 'explore_disinfect':
			val = $t('robot.explore_disinfect')
			break
		case 'deploy_disinfect':
			val = $t('robot.deploy_disinfect')
			break
		default:
			val = key;
			break;
	}
	return val
}

export const momentStamp = (type) => {
	const lan = getLanguage()
	// MMM Do YYYY, h:mm:ss a
	if (lan === 'en') {
		return type === 'dateTime' ? 'MMM Do YYYY, HH:mm:ss'
			: type === 'date' ? 'MMM Do YYYY'
				: type === 'time' ? 'HH:mm:ss'
					: 'MMM Do YYYY, HH:mm:ss'
	} else {
		return type === 'dateTime' ? 'YYYY-MM-DD HH:mm:ss'
			: type === 'date' ? 'YYYY-MM-DD'
				: type === 'time' ? 'HH:mm:ss'
					: 'YYYY-MM-DD HH:mm:ss'
	}
}
